<template>
    <CBadge>
        <slot />
    </CBadge>
</template>

<script setup>
import { CBadge } from '@coreui/vue-pro'
</script>

<style scoped>

</style>
